export class CompanyProfile {
    name: string;
    logoPath: string;
}